module.exports = __webpack_public_path__ + "static/plant-in-rental-car-zoom-1bb4b99bfdea934f180022ec9bdf1a66.jpg";